export default __webpack_public_path__ + "static/media/meslay6.6cc475c9.jpg";